// patients.js
import { ref, computed, watch } from "vue";
import { defineStore } from "pinia";
import moment from "jalali-moment";
import axios from "axios";
import { useToast } from "vue-toastification";
import apiClient from '@/axios';
import { useConfirm } from '@/stores/composables.js'

const API_URL = "/backend/";
export const usePatientsStore = defineStore("patients", () => {
  // --- STATE ---
  const patientsList = ref([]);
  const pagination = ref({
    total: 0,
    per_page: 5,
    current_page: 1,
    last_page: 1,
  });
  const searchQuery = ref("");
  const fileSerialCounter = ref(1);
  const customStart = ref(null);
  // 🟩 فیلترها را از فرم یا متغیرهای UI پر کن
  const filters = ref([
    // مثال: { column: "City", operator: "LIKE", value: "تهران" }
  ]);
  // ایجاد نمونه toast
  const toast = useToast();
  let debounceTimer = null;
  // --- GETTER ---
  const patientsWithAge = computed(() => {
    return patientsList.value.map((patient) => {
      let age = "";
      if (patient.birthDate && patient.birthDate !== "0000-00-00") {
        const birth = moment(patient.birthDate, "YYYY-MM-DD");
        if (birth.isValid()) {
          age = moment().diff(birth, "years");
        }
      }
      return { ...patient, age };
    });
  });

  // --- ACTIONS ---

  function setFileSerialStart(value) {
    let num = parseInt(value);
    if (isNaN(num) || num <= 0) {
      num = 1;
    }
    customStart.value = num;
    fileSerialCounter.value = num;
    // toast.success(`شمارنده شماره پرونده روی ${num} تنظیم شد`);
  }

  async function fetchPatients(page = pagination.value.current_page) {
    try {
      const requestBody = {
        filters: [], //  اضافه کردن فیلترهای دلخواه
        page,
        perPage: pagination.value.per_page,
        search: searchQuery.value,
        searchColumn: ["F_tname", "F_fami", "F_parno", "Pmeli", "Ptele"], // ستونی که می‌خوای جستجو بشه
        orderBy: "F_parno DESC"
      };

      const response = await apiClient.post("/Patient/GetAllAsync", requestBody);

      if (response.data && Array.isArray(response.data.result)) {
        patientsList.value = response.data.result;
        const total = response.data.totalCount || 0;
        pagination.value = {
          total: total,
          current_page: response.data.currentPage || page,
          per_page: response.data.perPage || 20,
          last_page: response.data.lastPage || 1
        };
        if (patientsList.value.length === 0) {
          toast.info("هیچ بیماری یافت نشد");
        }
      } else {
        console.error("Invalid API response:", response.data);
        patientsList.value = [];
        toast.error("خطا در دریافت اطلاعات بیماران");
      }
    } catch (error) {
      console.error("Error fetching patients:", error);
      patientsList.value = [];
      toast.error("خطا در ارتباط با سرور");
    }
  }

  //  تابع با تأخیر (debounce)
  function fetchPatientsWithDelay(page) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      fetchPatients(page);
    }, 600); // تأخیر ۶۰۰ میلی‌ثانیه
  }

  // واکنش به تغییر جستجو
  watch(searchQuery, () => {
    fetchPatientsWithDelay(1); // وقتی جستجو عوض شد، از صفحه اول شروع کن
  });

  async function addPatient(patientData) {
    console.log(patientData);
    try {
      if (!patientData.fileSerial || patientData.fileSerial <= 0) {
        patientData.fileSerial = fileSerialCounter.value;
        fileSerialCounter.value++;
      }

      const response = await apiClient.post("/Patient/Create", patientData);

      if (response.status === 200) {
        toast.success("بیمار با موفقیت اضافه شد");
        searchQuery.value = "";
        await fetchPatients(1);
      } else {
        toast.error(response.data.message || "خطا در افزودن بیمار");
      }
    } catch (error) {
      console.error("Error adding patient:", error);
      toast.error("خطا در افزودن بیمار");
    }
  }

  async function updatePatient(updatedData) {
    try {
      console.log(updatedData);
      const response = await apiClient.put("/Patient/Update", updatedData);

      if (response.status === 200) {
        toast.success("اطلاعات بیمار با موفقیت بروزرسانی شد");
        await fetchPatients(pagination.value.current_page);
      } else {
        toast.error(response.data.message || "خطا در بروزرسانی بیمار");
      }
    } catch (error) {
      console.error("Error updating patient:", error);
      toast.error("خطا در بروزرسانی بیمار");
    }
  }

  async function deletePatient(patientId) {
    const { confirm } = useConfirm();
    const confirmed = await confirm("آیا از حذف این بیمار اطمینان دارید؟")
    if (!confirmed) return;
    try {
      const response = await apiClient.delete(`/Patient/${patientId}`);

      if (response.status === 200) {
        toast.success("بیمار با موفقیت حذف شد");
        await fetchPatients(pagination.value.current_page);
      } else {
        toast.error(response.data.message || "خطا در حذف بیمار");
      }
    } catch (error) {
      console.error("Error deleting patient:", error);
      toast.error("خطا در حذف بیمار");
    }
  }

  async function getMaxPersonNumber() {
    try {
      const response = await apiClient.get("/Patient/GetMaxPersonNumber");
      debugger
      if (response.data && response.status == 200) {
        return response.data.toString()
      } else {
        toast.error("خطا در دریافت اطلاعات  شماره پرسنلی");
        return null;
      }
    } catch (error) {
      console.error("Error fetching Max Person Number:", error);
      toast.error("خطا در دریافت اطلاعات  شماره پرسنلی");
      return null;
    }
  }



  async function getPatientRecords(patientId) {
    try {
      const res = await apiClient.get(`Savabegh/GetAllAsyncById/${patientId}`);

      if (res.status === 200) {
        return res.data;
      } else {
        toast.error("خطا در دریافت سوابق بیمار");
        return [];
      }
    } catch (error) {
      console.error("Error fetching patient records:", error);
      toast.error("خطا در دریافت سوابق بیمار");
      return [];
    }
  }

  async function getPatientRecordPhotos(patientRecordId) {
    try {
      const res = await axios.get(`${API_URL}get_patient_record_photos.php`, {
        params: { record_id: patientRecordId }
      });

      if (res.data.status === 'success') {
        return res.data.photos;
      } else {
        toast.error("خطا در دریافت عکس‌های سوابق");
        return [];
      }
    } catch (error) {
      console.error("Error fetching patient record photos:", error);
      toast.error("خطا در دریافت عکس‌های سوابق");
      return [];
    }
  }

  async function savePatientRecordPhotos(formData) {
    try {
      const res = await axios.post(`${API_URL}upload_patient_record_photos.php`, formData);

      if (res.data.status === 'success') {
        toast.success("عکس‌ها با موفقیت آپلود شدند");
        return true;
      } else {
        toast.error(res.data.message || "خطا در آپلود عکس‌ها");
        return false;
      }
    } catch (err) {
      console.error(err);
      toast.error("خطا در آپلود عکس‌ها");
      return false;
    }
  }

  async function deletePatientRecordPhoto(photoId) {
    try {
      const formData = new FormData();
      formData.append('photo_id', photoId);

      const res = await axios.post(`${API_URL}delete_patient_record_photo.php`, formData);

      if (res.data.status === 'success') {
        toast.success("عکس با موفقیت حذف شد");
        return true;
      } else {
        toast.error(res.data.message || "خطا در حذف عکس");
        return false;
      }
    } catch (err) {
      console.error(err);
      toast.error("خطا در حذف عکس");
      return false;
    }
  }
  async function deletePatientRecord(recordId) {
    try {
      const formData = new FormData();
      formData.append('record_id', recordId)
      debugger
      const res = await axios.post(`${API_URL}delete_patient_record.php`, formData);

      if (res.data.status === 'success') {
        toast.success("سابقه با موفقیت حذف شد");
        return true;
      } else {
        toast.error(res.data.message || "خطا در حذف سابقه");
        return false;
      }
    } catch (err) {
      console.error(err);
      toast.error("خطا در حذف عکس");
      return false;
    }
  }
  async function addPatientRecord(formData) {
    try {
      const res = await axios.post(`${API_URL}create_patient_record.php`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })

      if (res.data.status) {
        toast.success("سابقه با موفقیت ثبت شد");

      } else {
        toast.error(res.data.message)
      }
    } catch (err) {
      toast.error('خطا در درج رکورد:', err)
    }
  }
  async function SendSMS(data) {
    try {
      const res = await apiClient.post('Sms/SendSms', data, {
        headers: { 'Content-Type': 'application/json' }
      })

      if (res.data == 0) {
        toast.success("ارسال پیام با موفقیت انجام شد");
      } else {
        toast.error("ارسال پیام با خطا مواجه شد");
      }
    } catch (err) {
      toast.error('خطا در ارسال پیام:', err)
    }
  }

  async function uploadPatientRecordFile(formData) {
    try {
      return await axios.post(`${API_URL}upload_patient_record_files.php`, formData);
    } catch (err) {
      console.error(err);
      toast.error('خطا در بارگزاری فایل');
    }
  }

  async function fetchPatientRecordFiles(patientId) {
    try {
      return await axios.get(`${API_URL}patient_list_file.php`, { params: { patientId: patientId } });
    } catch (err) {
      console.error(err);
      toast.error('خطا در دریافت اطلاعات');
    }
  }

  function downloadPatientRecordFile(id) {
    try {
      window.open(`${API_URL}download_patient_file.php?id=` + id, '_blank');
    } catch (err) {
      console.error(err);
      toast.error('خطا در دریافت فایل');
    }
  }

  async function deletePatientRecordFiles(id) {
    try {
      const res = await axios.post(`${API_URL}delete_patient_record_file.php`, { id });
      debugger
      if (res.data.status === 'success') {
        toast.success("فایل با موفقیت حذف شد");
        return true;
      } else {
        toast.error(res.data.message || "خطا در حذف فایل");
        return false;
      }
    } catch (err) {
      debugger
      console.error(err);
      toast.error("خطا در حذف فایل");
      return false;
    }
  }

  async function getPatientById(patientId) {
    try {
      const response = await apiClient.get(`Patient/${patientId}`);

      if (response.status === 200) {
        return response.data;
      } else {
        toast.error("خطا در دریافت اطلاعات بیمار");
        return null;
      }
    } catch (error) {
      console.error("Error fetching patient:", error);
      toast.error("خطا در دریافت اطلاعات بیمار");
      return null;
    }
  }


  async function uploadMultipleFiles(formData) {
    try {
      const response = await apiClient.post("Savabegh/UploadMultipleFiles", formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        timeout: 30000 // 30 ثانیه برای آپلود فایل
      });

      return response;
    } catch (err) {
      console.error('خطا در آپلود فایل‌ها:', err);

      if (err.response) {
        console.error('پاسخ خطا از سرور:', err.response.data);
        console.error('وضعیت خطا:', err.response.status);
      }

      throw err;
    }
  }
  async function getSavabeghFile(fSpauto, fSradif) {
    try {
      const response = await apiClient.get(`Savabegh/Download/${fSpauto}/${fSradif}`, {
        responseType: "blob"
      });

      if (response.status === 200) {
        const contentType = response.headers["content-type"];
        const contentDisposition = response.headers["content-disposition"];

        // استخراج نام فایل از هدر Content-Disposition
        let fileName = "downloaded_file";
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (fileNameMatch && fileNameMatch[1]) {
            fileName = fileNameMatch[1].replace(/['"]/g, '');
          }
        }

        const fileUrl = URL.createObjectURL(response.data);

        // تشخیص نوع فایل برای رفتار مناسب
        if (contentType.startsWith("image/")) {
          return {
            type: "image",
            url: fileUrl,
            name: fileName,
            contentType: contentType
          };
        } else if (contentType.startsWith("audio/")) {
          return {
            type: "audio",
            url: fileUrl,
            name: fileName,
            contentType: contentType
          };
        } else if (contentType.startsWith("video/")) {
          return {
            type: "video",
            url: fileUrl,
            name: fileName,
            contentType: contentType
          };
        } else if (contentType === "application/pdf") {
          return {
            type: "pdf",
            url: fileUrl,
            name: fileName,
            contentType: contentType
          };
        } else {
          return {
            type: "file",
            url: fileUrl,
            name: fileName,
            contentType: contentType
          };
        }
      } else {
        toast.error("خطا در دریافت فایل");
        return null;
      }
    } catch (error) {
      console.error("Error fetching file:", error);

      if (error.response?.status === 404) {
        toast.error("فایل مورد نظر یافت نشد");
      } else if (error.response?.status === 500) {
        toast.error("خطای سرور در دریافت فایل");
      } else {
        toast.error("خطا در دریافت فایل");
      }

      return null;
    }
  }
  async function deleteSavabegh(id) {
    try {
      const response = await apiClient.delete(`/Savabegh/${id}`);

      if (response.status === 200) {
        toast.success("سابقه با موفقیت حذف شد");
      } else {
        toast.error("خطا در حذف پزشک");
        console.error(response.data);
      }
    } catch (error) {
      console.error("Error deleting doctor:", error);
      toast.error("خطا در حذف سابقه");
    }
  }


  return {
    patientsList,
    pagination,
    searchQuery,
    patientsWithAge,
    fileSerialCounter,
    customStart,
    setFileSerialStart,
    fetchPatients,
    addPatient,
    updatePatient,
    deletePatient,
    getPatientById,
    getPatientRecords,
    getPatientRecordPhotos,
    savePatientRecordPhotos,
    deletePatientRecordPhoto,
    addPatientRecord,
    deletePatientRecord,
    uploadPatientRecordFile,
    fetchPatientRecordFiles,
    downloadPatientRecordFile,
    deletePatientRecordFiles,
    SendSMS,
    getMaxPersonNumber,
    uploadMultipleFiles,
    getSavabeghFile,
    deleteSavabegh
  };
});